import React, { useEffect } from 'react';
import RouteChangeTracking from '@Services/RouteChangeTracking';
import StructureEditorPage from './StructureEditorPage';

export default function StructureEditorPageComponent(props) {
  useEffect(() => {
    RouteChangeTracking.trackOnRouteChangeSuccess();
    const skipLinkFooter = document.getElementById('els-skiplink-footer');
    const footerListItem = skipLinkFooter ? skipLinkFooter.parentElement : null;
    if (footerListItem) {
      footerListItem.style.display = 'none'; // Hide the element that contains the skip link for footer
    }
    return () => {
      if (footerListItem) {
        footerListItem.style.display = ''; // Reset display to show the footer element again
      }
    };
  }, []);
  return <StructureEditorPage {...props} />;
}
